import { Button, Drawer, Flex, Text } from '@mantine/core';
import { DataTable } from '@shared/ui';
import {
  type VacancyTariffChangeLog,
  useGetVacancyTariffsHistory,
} from '@entities/vacancy';
import dayjs from 'dayjs';

type TariffHistoryDrawerProps = {
  opened: boolean;
  close: () => void;
  vacancyId: number;
};

const columns = [
  {
    accessor: 'activation_at',
    title: 'Дата установки',
    render: ({ activation_at }: VacancyTariffChangeLog) =>
      dayjs(activation_at).format('DD.MM.YYYY'),
  },
  {
    accessor: 'tariff_name',
    title: 'Наименование тарифа',
    render: ({ tariff_name }: VacancyTariffChangeLog) => (
      <Text truncate='end' title={tariff_name}>
        {tariff_name}
      </Text>
    ),
  },
];

export const TariffHistoryDrawer = ({
  opened,
  close,
  vacancyId,
}: TariffHistoryDrawerProps) => {
  const { data, isLoading, isFetching } = useGetVacancyTariffsHistory(
    vacancyId,
    { enabled: opened }
  );

  return (
    <Drawer
      opened={opened}
      onClose={close}
      title='История изменений'
      size='lg'
      position='right'
      styles={{
        content: {
          display: 'flex',
          flexDirection: 'column',
        },
        body: {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'space-between',
          overflowY: 'hidden',
        },
      }}
      keepMounted={false}
    >
      <DataTable
        columns={columns}
        records={data ?? []}
        fetching={isLoading || isFetching}
        height='100%'
      />

      <Flex mt='auto'>
        <Button variant='outline' onClick={close} mt={24}>
          Назад
        </Button>
      </Flex>
    </Drawer>
  );
};
